<h2 mat-dialog-title>{{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.TITLE' | translate }}</h2>

<mat-dialog-content>
  <p class="configure-categories__subtitle">
    {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.SUBTITLE' | translate }}
  </p>

  @if (isLoading()) {
    <app-foodback-loader />
  } @else {
    <form [formGroup]="configureForm" class="configure-categories">
      <section class="configure-categories__section">
        <header class="configure-categories__section-head">
          <h3 class="configure-categories__section-title">
            {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.CATEGORIES_SECTION' | translate }}
          </h3>
          <span class="configure-categories__section-hint">
            {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.DRAG_HINT' | translate }}
          </span>
        </header>

        <ul
          class="configure-categories__list"
          formArrayName="categories"
          cdkDropList
          (cdkDropListDropped)="drop($event)">
          @for (group of categoriesArray.controls; track group; let i = $index) {
            <li class="configure-categories__row" cdkDrag [formGroupName]="i">
              <mat-icon
                cdkDragHandle
                class="configure-categories__drag"
                [attr.aria-label]="
                  'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.DRAG_HANDLE' | translate
                "
                [attr.data-testid]="'drag-category-' + i">
                drag_indicator
              </mat-icon>

              <span class="configure-categories__index" aria-hidden="true">{{ i + 1 }}</span>

              <mat-form-field class="configure-categories__field" subscriptSizing="dynamic">
                <mat-label>{{ 'SHARED.SYSTEM.CATEGORY' | translate }} {{ i + 1 }}</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  formControlName="categoryName"
                  [required]="namesEditable()"
                  [readonly]="!namesEditable()"
                  [placeholder]="'SHARED.SYSTEM.NAME' | translate"
                  [attr.data-testid]="'input-category-name-' + i" />
                <mat-error [appErrors]="'categories.' + i + '.categoryName'" [errors]="errors" />
              </mat-form-field>
            </li>
          }
        </ul>
      </section>

      <section class="configure-categories__section">
        <header class="configure-categories__section-head">
          <h3 class="configure-categories__section-title">
            {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.BEHAVIOUR_SECTION' | translate }}
          </h3>
        </header>

        <div class="configure-categories__behaviour">
          <div class="configure-categories__behaviour-text">
            <p class="configure-categories__behaviour-title">
              {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.RANDOMIZE_TITLE' | translate }}
            </p>
            <p class="configure-categories__behaviour-desc">
              {{ 'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.RANDOMIZE_DESCRIPTION' | translate }}
            </p>
          </div>
          <mat-slide-toggle
            formControlName="randomizeCategoryOrder"
            data-testid="toggle-randomize-categories"
            [aria-label]="
              'SHARED.QUESTIONS.CONFIGURE_CATEGORIES_DIALOG.RANDOMIZE_TITLE' | translate
            " />
        </div>
      </section>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    matButton="outlined"
    type="button"
    class="me-1"
    data-testid="btn-cancel-configure-categories"
    (click)="cancel()">
    {{ 'SHARED.SYSTEM.CANCEL' | translate }}
  </button>

  <button
    matButton="filled"
    type="button"
    data-testid="btn-save-configure-categories"
    [disabled]="isLoading() || isSaving() || configureForm.invalid"
    (click)="submit()">
    {{ 'SHARED.SYSTEM.SAVE_CHANGES' | translate }}
  </button>
</mat-dialog-actions>
